import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import { AutoSave } from './AutoSave.jsx';
import { SaveAndCloseButton, CloseButton } from './TileActionButtons.jsx';

import { LeftButton, RightButton } from './StyledComponents';

export const NewFormMenu = ({ campaignId, onClose, autoSaved }) => {
  const history = useHistory();

  return (
    <>
      <LeftButton mode="outline" variant="black" onClick={onClose}>
        <SaveAndCloseButton />
      </LeftButton>
      <AutoSave autoSaved={autoSaved} />
      <RightButton
        mode="outline"
        onClick={() => history.push(`/${campaignId}/edit`)}
        variant="black"
      >
        <CloseButton />
      </RightButton>
    </>
  );
};

NewFormMenu.propTypes = {
  campaignId: PropTypes.string,
  onClose: PropTypes.func,
  autoSaved: PropTypes.shape({
    status: PropTypes.string,
    time: PropTypes.string,
  }),
};
